import { render, staticRenderFns } from "./UnregisteredVesselCreator.vue?vue&type=template&id=60d56a3f&scoped=true"
import script from "./UnregisteredVesselCreator.vue?vue&type=script&lang=ts"
export * from "./UnregisteredVesselCreator.vue?vue&type=script&lang=ts"
import style0 from "./UnregisteredVesselCreator.vue?vue&type=style&index=0&id=60d56a3f&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60d56a3f",
  null
  
)

export default component.exports